import { render, staticRenderFns } from "./SealCoordSettingModal.vue?vue&type=template&id=0c53d71c&scoped=true&"
import script from "./SealCoordSettingModal.vue?vue&type=script&lang=js&"
export * from "./SealCoordSettingModal.vue?vue&type=script&lang=js&"
import style0 from "./SealCoordSettingModal.vue?vue&type=style&index=0&id=0c53d71c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c53d71c",
  null
  
)

export default component.exports